var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "global"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 1.75C17.6539 1.75 22.25 6.34614 22.25 12C22.25 17.6539 17.6539 22.25 12 22.25C6.34614 22.25 1.75 17.6539 1.75 12C1.75 6.34614 6.34614 1.75 12 1.75ZM12 2.25C6.62386 2.25 2.25 6.62386 2.25 12C2.25 17.3761 6.62386 21.75 12 21.75C17.3761 21.75 21.75 17.3761 21.75 12C21.75 6.62386 17.3761 2.25 12 2.25Z",
    fill: "#9C4FFF",
    stroke: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.99977 2.75H8.99977C9.07417 2.75 9.15323 2.78845 9.20191 2.84961C9.25315 2.92443 9.26223 3.00665 9.23805 3.07617L9.23512 3.08203C7.321 8.83459 7.32116 15.1655 9.23512 20.9277L9.23805 20.9346C9.2612 21.0015 9.25217 21.0789 9.20582 21.1514C9.15551 21.2095 9.07492 21.25 8.99977 21.25H7.99977C7.86601 21.2499 7.74977 21.1338 7.74977 21C7.74977 20.8597 7.85514 20.7535 7.99195 20.75L8.64234 20.7344L8.45973 20.1094C6.91665 14.8412 6.91665 9.15879 8.45973 3.89062L8.64234 3.26562L7.99195 3.25C7.85514 3.24654 7.74977 3.14029 7.74977 3C7.74977 2.86622 7.86601 2.75014 7.99977 2.75Z",
    fill: "#9C4FFF",
    stroke: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9176 2.75421C15.0612 2.70926 15.1951 2.78591 15.2359 2.90851C17.1916 8.76577 17.1915 15.2149 15.2359 21.0618L15.234 21.0677L15.2311 21.0745C15.1979 21.1839 15.0997 21.2503 14.9996 21.2503C14.9622 21.2503 14.9446 21.245 14.9352 21.2415L14.9273 21.2386L14.9186 21.2357L14.8707 21.2142C14.7693 21.1546 14.7242 21.0301 14.7603 20.929L14.7643 20.9183C16.6784 15.1657 16.6782 8.83479 14.7643 3.07257V3.0716C14.7201 2.9386 14.7951 2.79533 14.9176 2.75421Z",
    stroke: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 17.2C9.21 17.2 6.43 16.81 3.75 16.02C3.74 16.42 3.41 16.75 3 16.75C2.59 16.75 2.25 16.41 2.25 16V15C2.25 14.76 2.37 14.53 2.56 14.39C2.76 14.25 3.01 14.21 3.24 14.29C8.89 16.17 15.12 16.17 20.77 14.29C21 14.21 21.25 14.25 21.45 14.39C21.65 14.53 21.76 14.76 21.76 15V16C21.76 16.41 21.42 16.75 21.01 16.75C20.6 16.75 20.27 16.43 20.26 16.02C17.57 16.81 14.79 17.2 12 17.2Z",
    fill: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21 9.75C20.92 9.75 20.84 9.74 20.76 9.71C15.11 7.83 8.88 7.83 3.23 9.71C2.83 9.84 2.41 9.63 2.28 9.24C2.16 8.84 2.37 8.42 2.76 8.29C8.72 6.3 15.28 6.3 21.23 8.29C21.62 8.42 21.84 8.85 21.7 9.24C21.61 9.55 21.31 9.75 21 9.75Z",
    fill: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.a8471f856cae513da579c570873e2921.svg";
export { ForwardRef as ReactComponent };